import React from 'react'
import { SectionWrapper } from "./SectionWrapper"
import LightTable from "../../../common/LightTable/LightTable"

const SummaryStructure = ({data, title, columns, handleChangeStep, canEdit}) => {
    return (
        <SectionWrapper
            id="summary-structure"
            title={title}
            canEdit={canEdit}
            handleChangeStep={handleChangeStep}
        >
            <LightTable
                data={data}
                columns={columns}
            />
        </SectionWrapper>
    )
}

export { SummaryStructure }